import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import Hidden from '@/components/ui/TzoHidden';
// import Countdown from 'react-countdown';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const ZeroneCoins = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Refer your friend and earn ZeroneCoin | TaxZerone ®"
          description="ZeroneCoin is a one-of-a-kind referral program that rewards clients who share the ease of tax filing with TaxZerone with their friends and family."
          keywords=""
          canonical="zeronecoins-a-referral-program/"
          jsonLdAggregateRatingValue="4.99"
          jsonLdAggregateRatingCount="166"
        />
      }
    >
      {/* <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            backgroundColor: '#2f3e46',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component={'div'}
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18 },
                color: '#e1e1e1',
                lineHeight: 1.3,
              }}
            >
              <strong>📢 It’s the Final Day! </strong> E-file your
              <b style={{ color: '#fff' }}> BOI report</b> now to ensure
              compliance with <b style={{ color: '#ffe5d9' }}>FinCEN!</b>
            </Typography>
            {
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: 'center',
                    mb: { xs: 1, sm: 1 },
                    lineHeight: 1.3,
                  }}
                >
                  Time Left Until the Deadline:
                </Typography>
                <Countdown date={lastDayTaxSeason} renderer={renderer} />
              </Box>
            }
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                File BOI Report Now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container> */}
      <Box sx={{}}>
        <Container maxWidth="xl">
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={3}
            sx={{ px: { xs: 2, md: 0 } }}
          >
            <Box
              sx={{
                textAlign: { xs: 'center', md: 'left' },
                alignItems: 'center',
                display: 'flex',
                width: '100%',
                maxWidth: { xs: 'inherit', lg: 770 },
                minWidth: { xs: 'inherit', md: 530 },
                pl: { xs: 0, md: 6, lg: 8, xl: 12 },
                justifyContent: 'center',
              }}
            >
              <Box
                component="div"
                sx={{
                  mt: { xs: 2, sm: 4, md: 5 },
                  mb: { xs: 2, sm: 4, md: 5 },
                }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                    fontWeight: 600,
                    color: '#374151',
                    mb: 3,
                  }}
                >
                  Spread the{' '}
                  <span className="highlight-container">
                    <span className="highlight">Good news!</span>
                  </span>{' '}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  You’ve experienced the Simple, Secure and affordable way of
                  tax filing — now it’s your turn to Share TaxZerone with your
                  friends and family, and help them enjoy the same convenience.
                  As a{' '}
                  <Hidden mdDown>
                    {' '}
                    <br />
                  </Hidden>
                  thank-you for spreading the word, you’ll earn ZeroneCoins — a
                  small reward for making a difference.
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                  sx={{ mt: 4 }}
                >
                  <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                    <Button
                      variant="contained"
                      className="btn-primary"
                      sx={{
                        zIndex: 99,
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=zcoin`}
                    >
                      Refer & Earn Now
                    </Button>
                  </Box>
                </Stack>
              </Box>
            </Box>
            <Hidden mdDown>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  width: '100%',
                }}
              >
                <picture style={{ marginBottom: -7 }}>
                  <source srcSet="/assets/images/zcoin-landing-img.webp" />
                  <source srcSet="/assets/images/zcoin-landing-img.png" />
                  <img
                    src="/assets/images/zcoin-landing-img.png"
                    alt="Spread the Good news!"
                    className="img-responsive-banner"
                    width={880}
                    height={725}
                  />
                </picture>
              </Box>
            </Hidden>
            <Hidden mdUp smDown>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-end',
                  width: '100%',
                  backgroundPosition: 'center center !important',
                  mt: '0 !important',
                }}
              >
                <picture style={{ marginBottom: -7 }}>
                  <source srcSet="/assets/images/zcoin-landing-img-sm.webp" />
                  <source srcSet="/assets/images/zcoin-landing-img-sm.png" />
                  <img
                    src="/assets/images/zcoin-landing-img-sm.png"
                    alt="Spread the Good news!"
                    className="img-responsive-banner"
                    width={440}
                    height={365}
                  />
                </picture>
              </Box>
            </Hidden>
          </Stack>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid
            container
            spacing={2}
            sx={{ mt: 2, textAlign: 'center', justifyContent: 'center' }}
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                What are ZeroneCoins?
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 4, md: 2.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 0,
                  borderRadius: 3,
                  minHeight: '100%',
                  width: { xs: '100%', sm: '100%' },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    borderTopRightRadius: 12,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/referral-img-new.webp" />
                    <source srcSet="/assets/images/referral-img-new.png" />
                    <img
                      src="/assets/images/referral-img-new.png"
                      alt="Your Referral"
                      loading="lazy"
                      width={225}
                      height={225}
                      style={{
                        borderRadius: '12px 12px 0 0',
                        width: '100%',
                        height: '100%',
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ mt: 2, mb: 2, p: 1 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 19, xs: 17 },
                      mb: 1,
                    }}
                  >
                    Your Referral
                  </Typography>{' '}
                  <Typography variant="body1">
                    Spread the news of early tax filing
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Hidden mdDown>
              <Grid size={{ xs: 12, sm: 4, md: 2 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 0,
                    backgroundColor: 'transparent',
                    border: 'none',
                    minHeight: '100%',
                    alignContent: 'center',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                      mt: -20,
                      borderTopRightRadius: 12,
                    }}
                  >
                    <img
                      src="/assets/images/add-icon.svg"
                      alt="Plus"
                      loading="lazy"
                      width={150}
                      height={150}
                      style={{ borderRadius: 12 }}
                    />
                  </Box>
                </Paper>
              </Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 4, md: 2.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 0,
                  borderRadius: 3,
                  minHeight: '100%',
                  width: { xs: '100%', sm: '100%' },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    borderTopRightRadius: 12,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/thank-img.webp" />
                    <source
                      srcSet="/assets/images/thank-img.png"
                      width={225}
                      height={225}
                    />
                    <img
                      src="/assets/images/thank-img.png"
                      alt="Thank you"
                      loading="lazy"
                      width={225}
                      height={225}
                      style={{
                        borderRadius: '12px 12px 0 0',
                        width: '100%',
                        height: '100%',
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ mt: 2, mb: 2, p: 1 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,

                      mb: 1,
                      fontSize: { md: 22, sm: 19, xs: 17 },
                    }}
                  >
                    Our Thanks
                  </Typography>{' '}
                  <Typography variant="body1">
                    We thanks for the opportunity to serve one more tax payer
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={{ xs: 12, sm: 4, md: 2 }}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 0,
                    backgroundColor: 'transparent',
                    border: 'none',
                    minHeight: '100%',
                    alignContent: 'center',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                      mt: -20,
                      borderTopRightRadius: 12,
                    }}
                  >
                    <img
                      src="/assets/images/equal-icon.svg"
                      alt="equal"
                      loading="lazy"
                      width={150}
                      height={150}
                      style={{ borderRadius: 12 }}
                    />
                  </Box>
                </Paper>
              </Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 4, md: 2.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 0,
                  borderRadius: 3,
                  minHeight: '100%',
                  width: { xs: '100%', sm: '100%' },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    borderTopRightRadius: 12,
                  }}
                >
                  <picture style={{}}>
                    <source srcSet="/assets/images/reward-coin-img.webp" />
                    <source srcSet="/assets/images/reward-coin-img.png" />
                    <img
                      src="/assets/images/reward-coin-img.png"
                      alt="ZERONECOINS"
                      loading="lazy"
                      width={225}
                      height={225}
                      style={{
                        borderRadius: '12px 12px 0 0',
                        width: '100%',
                        height: '100%',
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ mt: 2, mb: 2, p: 1 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 19, xs: 17 },
                      mb: 1,
                    }}
                  >
                    ZeroneCoins
                  </Typography>{' '}
                  <Typography variant="body1">
                    You reward for spreading the{' '}
                    <span style={{ fontWeight: 600 }}> NEWS</span>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How it Works
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/invite-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/invite-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/invite-steps-img.png"
                  alt="How it Works "
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Types of Filing"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18 }}
                    >
                      Refer a Friend
                    </Typography>
                    <Typography variant="body1">
                      Share your unique referral link or invite code with
                      friends, family, or colleagues — anyone who needs to file
                      their taxes.{' '}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Company Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18 }}
                    >
                      Signs Up & Files
                    </Typography>
                    <Typography variant="body1">
                      Your referral creates an account on TaxZerone and
                      completes their first tax filing using our platform.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Company Applicant Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, fontSize: 18 }}
                    >
                      You Earn ZeroneCoins
                    </Typography>
                    <Typography variant="body1">
                      Once their tax filing is successfully submitted,
                      you&apos;ll receive ZeroneCoins equal to 20% of their
                      filing fee — automatically credited to your account
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
            </Box>
          </Stack>
          <Box
            id="deadlines"
            sx={{ mb: { lg: 8, md: 8, sm: 8, xs: 4 }, mt: -10 }}
          >
            &nbsp;
          </Box>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            // direction={{ md: 'row', sm: 'row', xs: 'column-reverse' }}
            pb={{ xs: 0, sm: 4, md: 8 }}
            pt={{ xs: 0, sm: 2, md: 4 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid
              size={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <Box
                component="div"
                // sx={{
                //   textAlign: 'left',
                //   display: 'flex',
                //   alignItems: 'center',
                //   justifyContent: 'center',
                // }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 0,
                  }}
                >
                  Benefits of earning ZeroneCoins
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#333',
                  borderRadius: 10,
                  mt: { xs: 0, md: 0 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/discount-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/discount-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/discount-icon.png"
                      alt="Exclusive Discounts"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Exclusive Discounts
                </Typography>
                <Typography variant="body1">
                  ZeroneCoins can be redeemed on future tax filings, because
                  smart referrals deserve smarter rewards.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#333 ',
                  borderRadius: 10,
                  mt: { xs: 0, md: 0 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/coin-grow-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/coin-grow-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/coin-grow-icon.png"
                      alt="Coins That Grow"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Coins That Grow
                </Typography>
                <Typography variant="body1">
                  watch your ZeroneCoins stack up and unlock even bigger, better
                  rewards the more you share.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#333',
                  borderRadius: 10,
                  mt: { xs: 0, md: 0 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/first-time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/first-time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/first-time-icon.png"
                      alt="First Time? Big Time!"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  First Time? Big Time!
                </Typography>
                <Typography variant="body1">
                  Your referred friend gets an exclusive discount when they make
                  their first payment on TaxZerone.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            py: { lg: 8, md: 8, sm: 4, xs: 4 },
          }}
        >
          <Grid container spacing={2} className="MuiGrid-root-width">
            <Grid
              size={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 2,

                    lineHeight: 1.5,
                  }}
                >
                  Track your Rewards
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 2, fontSize: { md: 20, sm: 18, xs: 16 } }}
                >
                  At TaxZerone, transparency is key. Easily track all your
                  referrals, earned rewards,
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>{' '}
                  and ZeroneCoins in your personalized ZeroneCoin Dashboard.
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            mt={3}
            direction={{ xs: 'column-reverse', sm: 'row' }}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 600,
                  fontSize: { md: 24, sm: 20, xs: 18 },
                  mb: 2,
                }}
              >
                You can{' '}
              </Typography>
              <Stack spacing={2} direction="column">
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    display: 'grid',
                    gridTemplateColumns: 'auto auto ',
                    columnGap: 1,
                    placeContent: 'start',
                    borderRadius: 3,
                    maxWidth: '100%',
                    minWidth: '100%',
                    alignSelf: 'center',
                    backgroundColor: '#f0f2f9',
                    transition: 'all 0.3s ease-in-out',
                    border: 'none',
                    '&:hover': {
                      boxShadow: 'rgba(0, 0, 0, 0.20) 1px 0px 25px 0px',
                      transition: '0.3s',
                      backgroundColor: '#fff',
                    },
                    '& .MuiBox-root:hover': {
                      backgroundColor: '#f0f2f9',
                    },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#fff',
                      borderRadius: '50%',
                      width: 70,
                      height: 70,
                      m: 'auto',
                      textAlign: 'center',
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {' '}
                    <picture style={{ width: 50, height: 50 }}>
                      <source
                        srcSet="/assets/images/referral-3d-icon.webp"
                        width={50}
                        height={50}
                      />
                      <source
                        srcSet="/assets/images/referral-3d-icon.png"
                        width={50}
                        height={50}
                      />
                      <img
                        src="/assets/images/referral-3d-icon.png"
                        alt="Know exactly which friends"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                  </Box>{' '}
                  <Typography variant="body1" sx={{ alignSelf: 'center' }}>
                    Know exactly which friends have joined through your
                    referral.{' '}
                  </Typography>
                </Paper>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    display: 'grid',
                    gridTemplateColumns: 'auto auto ',
                    columnGap: 1,
                    placeContent: 'start',
                    borderRadius: 3,
                    maxWidth: '100%',
                    minWidth: '100%',
                    alignSelf: 'center',
                    backgroundColor: '#f0f2f9',
                    border: 'none',
                    '&:hover': {
                      boxShadow: 'rgba(0, 0, 0, 0.20) 1px 0px 25px 0px',
                      transition: '0.3s',
                      backgroundColor: '#fff',
                    },
                    '& .MuiBox-root:hover': {
                      backgroundColor: '#f0f2f9',
                    },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#fff',
                      borderRadius: '50%',
                      width: 70,
                      height: 70,
                      m: 'auto',
                      textAlign: 'center',
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {' '}
                    <picture style={{ width: 50, height: 50 }}>
                      <source
                        srcSet="/assets/images/tax-file-3d-icon.webp"
                        width={50}
                        height={50}
                      />
                      <source
                        srcSet="/assets/images/tax-file-3d-icon.png"
                        width={50}
                        height={50}
                      />
                      <img
                        src="/assets/images/tax-file-3d-icon.png"
                        alt="tax filings with TaxZerone."
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                  </Box>{' '}
                  <Typography variant="body1" sx={{ alignSelf: 'center' }}>
                    See which referrals have completed their tax filings with
                    TaxZerone.
                  </Typography>
                </Paper>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    display: 'grid',
                    gridTemplateColumns: 'auto auto ',
                    columnGap: 1,
                    placeContent: 'start',
                    borderRadius: 3,
                    maxWidth: '100%',
                    minWidth: '100%',
                    alignSelf: 'center',
                    backgroundColor: '#f0f2f9',
                    border: 'none',
                    '&:hover': {
                      boxShadow: 'rgba(0, 0, 0, 0.20) 1px 0px 25px 0px',
                      transition: '0.3s',
                      backgroundColor: '#fff',
                    },
                    '& .MuiBox-root:hover': {
                      backgroundColor: '#f0f2f9',
                    },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#fff',
                      borderRadius: '50%',
                      width: 70,
                      height: 70,
                      m: 'auto',
                      textAlign: 'center',
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {' '}
                    <picture style={{ width: 50, height: 50 }}>
                      <source
                        srcSet="/assets/images/collection-3d-icon.webp"
                        width={50}
                        height={50}
                      />
                      <source
                        srcSet="/assets/images/collection-3d-icon.png"
                        width={50}
                        height={50}
                      />
                      <img
                        src="/assets/images/collection-3d-icon.png"
                        alt="Know exactly which friends"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                  </Box>{' '}
                  <Typography variant="body1" sx={{ alignSelf: 'center' }}>
                    Track how many ZeroneCoins you’ve collected so far.
                  </Typography>
                </Paper>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    display: 'grid',
                    gridTemplateColumns: 'auto auto ',
                    columnGap: 1,
                    placeContent: 'start',
                    borderRadius: 3,
                    maxWidth: '100%',
                    minWidth: '100%',
                    alignSelf: 'center',
                    backgroundColor: '#f0f2f9',
                    border: 'none',
                    '&:hover': {
                      boxShadow: 'rgba(0, 0, 0, 0.20) 1px 0px 25px 0px',
                      transition: '0.3s',
                      backgroundColor: '#fff',
                    },
                    '& .MuiBox-root:hover': {
                      backgroundColor: '#f0f2f9',
                    },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#fff',
                      borderRadius: '50%',
                      width: 70,
                      height: 70,
                      m: 'auto',
                      textAlign: 'center',
                      alignItems: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    {' '}
                    <picture style={{ width: 50, height: 50 }}>
                      <source
                        srcSet="/assets/images/reward-3d-icon.webp"
                        width={50}
                        height={50}
                      />
                      <source
                        srcSet="/assets/images/reward-3d-icon.png"
                        width={50}
                        height={50}
                      />
                      <img
                        src="/assets/images/reward-3d-icon.png"
                        alt="Know exactly which friends"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                  </Box>{' '}
                  <Typography variant="body1" sx={{ alignSelf: 'center' }}>
                    View your coin redemption history and how you’ve used your
                    reward
                  </Typography>
                </Paper>
              </Stack>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: 'center',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/tracking-reward-img.webp" />
                  <source srcSet="/assets/images/tracking-reward-img.png" />
                  <img
                    src="/assets/images/tracking-reward-img.png"
                    alt="Track your Rewards"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={510}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          File smart. Share smarter. Save together.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Help your friends discover a better way to file — and get rewarded
          <br /> with ZeroneCoins for every successful referral.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=zcoin`}
          >
            Refer Now!
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is ZeroneCoins?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Zerone Coin is TaxZerone’s exclusive referral reward —
                    designed to thank and reward our loyal clients. When you
                    refer to friends or family who file their taxes forms with
                    us, you earn ZeroneCoins as a token of appreciation. These
                    coins can be redeemed for discounts on future filings and
                    services.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. How do I earn ZeroneCoins?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    You earn ZeroneCoins by referring your friends and family to
                    file their tax forms with TaxZerone. When your referred
                    friend completes their first tax filing, 20% of their filing
                    fee is converted into ZeroneCoins and automatically added to
                    your account.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Where can I Spend Zerone Coins?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      You can use ZeroneCoins to get exclusive discounts on
                      future tax filings with TaxZerone. Each ZeroneCoin holds
                      real value.
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, fontWeight: 600 }}>
                      1 ZeroneCoin = 1 cent{' '}
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      So,{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        100 ZeroneCoins = $1 off your filing fee.
                      </span>
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Simply apply your available coins at checkout to reduce
                      your total payment.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Can I use ZeroneCoins for anything other than tax filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Currently, ZeroneCoins can only be used to get discounts on
                    filing fees within TaxZerone. However, we’re actively
                    expanding our partner network to bring you even more ways to
                    redeem your coins — including exclusive coupons, offers, and
                    services beyond tax filing. Stay tuned for exciting updates!
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ZeroneCoins;
